
import {Component, inject, OnInit} from '@angular/core';
import {ExamService} from "../../../data-access/exam.service";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {
  faAdd, faEye,
  faTrash, faXmark
} from "@fortawesome/free-solid-svg-icons";
import {ActivatedRoute, Router} from "@angular/router";
import {OutlineButtonComponent} from "../../../../shared/ui/outline-button/outline-button.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormsModule} from "@angular/forms";
import {MatIconModule} from "@angular/material/icon";
import {FullButtonComponent} from "../../../../shared/ui/full-button/full-button.component";
import _ from "lodash";
import {BreadcrumbComponent, BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";
import { ExamField, GenericField, PartDifferentiator, PartField, QuestionDifferentiator, QuestionField, UserField } from './exam-export-enum';
import { DropdownItem, SectionedDropdownComponent } from "src/app/shared/ui/sectioned-dropdown/sectioned-dropdown.component";
import {CommonModule} from "@angular/common";
import {ContentService} from "../../../../admin/data-access/content.service";
import {
  FullProblemTemplate
} from "../../../../admin/feature/contentViewer/problemTemplatePreview/problemTemplatePreview.component";
import {MultifieldComponent} from "../../../../shared/ui/problem-templates/multifield/multifield.component";
import {MultipleChoiceComponent} from "../../../../shared/ui/problem-templates/multiplechoice/multiplechoice.component";
import {MathjaxModule} from "mathjax-angular";

interface csvCell {
  name: string
  value: string
  part_selector_value?: string
  question_selector_value?: string
  generic_value?: string
  problemtemplate_id?: number
}
interface csvJson {
  name: string
  exam_id: number
  columns: csvColumn[]
  report_id?: number
}
interface csvColumn {
  name: string,
  data_source: any
}
interface selectKeyValue {
  key: string
  value: string
}
interface Part {
  exampart_id: string
  part_name: string
  questions: Question[]
}
interface Question {
  question_position: string
  problemtemplate_name: string
  problemtemplate_id: number
}
interface DataSource {
  generic?: string
  user?: string
  exam?: string
  part?: string
  question?: string
  part_selector?: string
  question_selector?: string
  part_differentiator?: string
  question_differentiator?: string
  generic_value?: string
  part_selector_value?: string
  question_selector_value?: string
}

@Component({
  standalone: true,
  selector: 'exam-export-config',
  templateUrl: './exam-export-config.component.html',
  styleUrls: ['../../../../admin/feature/userManagement/userRoleAddEdit/userRoleAddEdit.css', './exam-export-config.component.css'],
  imports: [CommonModule, FontAwesomeModule, OutlineButtonComponent, FormsModule, MatIconModule, FullButtonComponent, BreadcrumbComponent, SectionedDropdownComponent, MultifieldComponent, MultipleChoiceComponent, MathjaxModule],
})
export class ExamExportConfigComponent implements OnInit {
  constructor(private examService: ExamService, private route: ActivatedRoute, private _snackBar: MatSnackBar) {}
  router = inject(Router)
  contentService = inject(ContentService)
  csvColumns: csvCell[] = [{name: '', value: 'null'}]
  examID = -1
  reportID = -1
  reportName = ''
  selectValues: selectKeyValue[] = []
  parts: Part[] = []
  dropdownPartItems: DropdownItem[] = []
  dropdownQuestionItems: DropdownItem[][] = []
  previewDialog = false
  previewProblemTemplate: FullProblemTemplate = {
    answerSkeleton: [],
    answers: [],
    clusters: [],
    details: {
      allItems: [],
      allGroups: []
    },
    learningobjective_id: 0,
    mathjax: false,
    problemtemplate_id: 0,
    problemtemplate_name: "",
    question_text: "",
    reasons: [],
    sampleCases: [],
    samplesInitial: 0,
    samplesRemaining: 0,
    type: "",
    values: []
  }

  breadcrumbNavs: BreadcrumbNavigation[] = [{
    text: 'Exam List',
    route: 'dashboard/exam/list'
  }, {
    text: 'Exam Export List',
    route: 'dashboard/exam/export/list',
    queryParams: {queryParams: {exam_id: this.examID}}
  }]

  items: any[] = [
      {
        label: 'Generic',
        parentSelectable: false,
        subitems: [] as any[]
      },
      {
      label: 'Student',
      parentSelectable: false,
      subitems: [] as any[]
    },
      {
      label: 'Exam',
      parentSelectable: false,
      subitems: [] as any[]
    },
      {
      label: 'Part',
      parentSelectable: false,
      subitems: [] as any[]
    },
    {
      label: 'Question Fields',
      parentSelectable: false,
      subitems: [] as any[]
    },
  ]

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params['exam_id']) {
        this.examID = params['exam_id']
        this.breadcrumbNavs[1].queryParams = {queryParams: {exam_id: this.examID}};
        this.getExamDetails()
      }

      if(params['report_id']) {
        this.reportID = params['report_id']
        this.getReportDetails()
      }
    })
  }

  getReportDetails() {
    this.examService.exportReportDetails(this.reportID).subscribe((response) => {
      if(response.success) {
        this.reportName = response.result.name
        this.csvColumns = []
        const data_sources = response.result.columns.map((obj: any) => _.omitBy(obj.data_source,  _.isNull))
        for(let i = 0; i < response.result.columns.length; i++) {
          const key = Object.keys(data_sources[i])[0]
          const value = Object.values(data_sources[i])[0]
          let part_selector_value: string | undefined = undefined
          let question_selector_value: string | undefined = undefined
          let generic_value: string | undefined = undefined
          if(data_sources[i].part_selector_value != undefined) {
            part_selector_value = data_sources[i].part_selector_value
          }
          if(data_sources[i].question_selector_value != undefined) {
            question_selector_value = data_sources[i].question_selector_value
          }
          if(data_sources[i].generic_value != undefined) {
            generic_value = data_sources[i].generic_value
          }

          this.csvColumns.push({
            name: response.result.columns[i].name,
            value: `${key} ${value}`,
            part_selector_value: part_selector_value,
            question_selector_value: question_selector_value,
            generic_value: generic_value,
          })
        }
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {duration: 5000, panelClass: ['error-snackbar']})
      }
    })
  }

  getExamDetails() {
    this.examService.exportReportFields(this.examID).subscribe((response) => {
      if(response.success) {
        for(let generic of response.result.generic_fields) {
          this.items[0].subitems.push({
            label: GenericField[generic as keyof typeof GenericField],
            value: 'generic ' + generic
          })
        }
        for(let user of response.result.user_fields) {
          this.items[1].subitems.push({
            label: UserField[user as keyof typeof UserField],
            value: 'user ' + user
          })
        }
        for(let exam of response.result.exam_fields) {
          this.items[2].subitems.push({
            label: ExamField[exam as keyof typeof ExamField],
            value: 'exam ' + exam
          })
        }
        for(let part of response.result.part_fields) {
          this.items[3].subitems.push({
            label: PartField[part as keyof typeof PartField],
            value: 'part ' + part
          })
        }
        for(let question_fields of response.result.question_fields) {
          this.items[4].subitems.push({
            label: QuestionField[question_fields as keyof typeof QuestionField],
            value: 'question ' + question_fields
          })
        }
        for(let i = 0; i < response.result.exam_details.parts.length; i++) {
          let questions: Question[][] = []
          let qindex = 0
          for(let qpool of response.result.exam_details.parts[i].qpools) {
            if(this.dropdownQuestionItems[i] == undefined) {
              this.dropdownQuestionItems[i] = []
            }
            for(let question of qpool.questions) {
              this.dropdownQuestionItems[i].push({
                label: question.problemtemplate_name,
                value: qindex
              })
              qindex++
            }
            if(questions[i] == undefined) {
              questions[i] = []
            }
            questions[i].push(...qpool.questions)
          }
          this.parts.push({
            part_name: response.result.exam_details.parts[i].part_name,
            exampart_id: response.result.exam_details.parts[i].exampart_id,
            questions: questions[i]
          })

          this.dropdownPartItems.push({
            label: response.result.exam_details.parts[i].part_name,
            value: i
          })
        }
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {duration: 5000, panelClass: ['error-snackbar']})
      }
    })
  }

  columnPush(column: csvColumn[], cell: csvCell, data_source_name: string, part_selector_value?: string, question_selector_value?: string, generic_value?: string): csvColumn[] {
    if(part_selector_value != undefined && question_selector_value != undefined) {
      column.push({
        name: cell.name,
        data_source: {
          [data_source_name]: cell.value.split(' ')[1],
          part_selector_value: part_selector_value,
          part_selector: 'part_position',
          question_selector_value: question_selector_value,
          question_selector: 'question_position'
        }
      })
    } else if(part_selector_value != undefined) {
      column.push({
        name: cell.name,
        data_source: {
          [data_source_name]: cell.value.split(' ')[1],
          part_selector_value: part_selector_value,
          part_selector: 'part_position'
        }
      })
    } else if(generic_value != undefined) {
      column.push({
        name: cell.name,
        data_source: {
          [data_source_name]: cell.value.split(' ')[1],
          generic_value: generic_value
        }
      })
    }  else {
      column.push({
        name: cell.name,
        data_source: {
          [data_source_name]: cell.value.split(' ')[1]
        }
      })
    }
    return column
  }

  saveCSV() {
    let json: csvJson = {
      columns: [],
      name: this.reportName,
      exam_id: this.examID,
      report_id: this.reportID
    }
    for(let column of this.csvColumns) {
      if(column.value.includes('generic')) {
        json.columns = this.columnPush(json.columns, column, 'generic', undefined, undefined, column.generic_value)
      }
      else if(column.value.includes('user')) {
        json.columns = this.columnPush(json.columns, column, 'user')
      } else if(column.value.includes('part')) {
        json.columns = this.columnPush(json.columns, column, 'part', column.part_selector_value)
      } else if(column.value.includes('part_selectors')) {
        json.columns = this.columnPush(json.columns, column, 'part_selector')
      } else if(column.value.includes('exam')) {
        json.columns = this.columnPush(json.columns, column, 'exam')
      }
      else if(column.value.includes('question')) {
        json.columns = this.columnPush(json.columns, column, 'question', column.part_selector_value, column.question_selector_value)
     }
    }
    this.examService.exportReportSave(JSON.stringify(json)).subscribe((response) => {
      if(response.success) {
        this._snackBar.open('CSV config successfully saved', 'Dismiss', {duration: 5000})
        this.router.navigate(['dashboard/exam/export/list'], {queryParams: {exam_id: this.examID}})
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {duration: 5000, panelClass: ['error-snackbar']})
      }
    })
  }

  examList() {
    this.router.navigate(['dashboard/exam/list'])
  }

  examExportList() {
    this.router.navigate(['dashboard/exam/export/list'], {queryParams: {exam_id: this.examID}})
  }

  openPreviewDialog(index: number) {
    const part = Number(this.csvColumns[index].part_selector_value);
    const question = Number(this.csvColumns[index].question_selector_value);

    this.contentService.getProblemTemplatePreview(this.parts[part].questions[question].problemtemplate_id).subscribe((response) => {
      if (response.success) {
        this.previewProblemTemplate = response.result[0]
        this.previewDialog = true
      }
    })
  }

  protected readonly faAdd = faAdd;
  protected readonly faTrash = faTrash;
  protected readonly Number = Number;
  protected readonly faEye = faEye;
  protected readonly faXmark = faXmark;
}
